import React from "react"
import classnames from "classnames"
import { P } from "AtomicComponents"
import styles from "./CheckBoxGroup.less"
import checkboxStyles from "../InputCheckBox/InputCheckBox.less"
import CheckIcon from "../Icons/CheckIcon"

class CheckBoxGroup extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      checkedItems: props.items.filter(item => item.checked).map(item => item && item.value)
    }

    // for testing purposes
    if (process && process.env && process.env.NODE_ENV === 'test') {
      this.random = 1
    } else {
      this.random = Math.random()
    }
  }

  componentDidMount() {
    const { onChange = () => { } } = this.props
    const { checkedItems } = this.state

    if (checkedItems.length) {
      // Delay to allow for the update of all checkboxes
      setTimeout(() => {
        onChange(checkedItems)
      }, 200)
    }
  }

  _onBlurHandler = () => {
    const { onBlur = () => { } } = this.props
    onBlur()
  }

  _onChangeHandler = (event) => {
    const { onChange = () => { }, items } = this.props
    const name = event.target.name
    const value = items.find(item => (item.name === name)).value
    const isChecked = event.target.checked

    this.setState(prevState => ({
      checkedItems: isChecked ? [...prevState.checkedItems, value] : prevState.checkedItems.filter(item => item && item !== value)
    }), () => {
      onChange(this.state.checkedItems.length ? this.state.checkedItems : null)
    })
  }

  render() {
    const {
      items = [],
      heading,
      required = false,
      styleName = "normal",
      message = "",
      isValid = true
    } = this.props
    const { checkedItems } = this.state

    return (
      <div className={classnames({
        [styles.CheckBoxGroup]: true
      })}>
        <P withoutMargin>
          {heading}
          {required &&
            <span className={classnames({
              [styles.requiredStar]: true
            })}>*</span>
          }
        </P>
        <div className={classnames({
          [styles.CheckBoxWrapper]: true,
          [styles.CheckBoxWrapperCompact]: styleName === "compact"
        })}>
          {
            items &&
            items.map(item => (
              <div
                key={item.value}
                className={classnames({
                  [checkboxStyles.InputCheckBox]: true,
                  [checkboxStyles.InputCheckBoxLarge]: true,
                  [styles.InputCheckBox]: true
                })}>
                <input
                  checked={checkedItems.indexOf(item.value) !== -1}
                  className={classnames({
                    [checkboxStyles.InputCheckBoxInput]: true
                  })}
                  name={`${item.name}`}
                  id={`${item.name}-${this.random}`}
                  type={"checkbox"}
                  onChange={this._onChangeHandler}
                  onBlur={this._onBlurHandler}
                />
                <label
                  ref={c => this.label = c}
                  htmlFor={`${item.name}-${this.random}`}
                  className={classnames({
                    [checkboxStyles.LabelCheckBox]: true
                  })}>
                  <CheckIcon style={{
                    width: "10px",
                    padding: "3px"
                  }}/>
                </label>
                <label
                  htmlFor={`${item.name}-${this.random}`}
                  className={classnames({
                    [checkboxStyles.Label]: true
                  })}>
                  {item.name}
                </label>
              </div>
            ))
          }
        </div>
        <div className={classnames({
          [styles.message]: true,
          [styles.messageShow]: !isValid
        })}>
          {message}
        </div>
      </div>
    )
  }
}

export default CheckBoxGroup



// WEBPACK FOOTER //
// ./src/AtomicComponents/CheckBoxGroup/CheckBoxGroup.jsx